import * as React from "react";
import {match, Route, Switch} from "react-router";
import AdminRoute from "./route/AdminRoute";
import CategoriesConfigView from "../components/admin/categories/CategoriesConfigView";
import LeadTypesConfigView from "../components/admin/leadTypes/LeadTypesConfigView";
import AcquisitionChannelConfigView from "../components/admin/acquisitionChannels/AcquisitionChannelConfigView";
import PostcodesList from "../components/admin/postcodes/PostcodesList";
import JobStatusesList from "../components/admin/jobStatuses/JobStatusesList";
import LeadStatusesRouter from "./LeadStatusesRouter";
import BrandRouter from "./BrandRouter";
import AssetCategoryConfigView from "../components/admin/assetCategory/AssetCategoryConfigView";
import TaskList from "../components/admin/tasks/TaskList";
import SurveyRouter from "./SurveyRouter";
import PartnerBrandRouter from "./PartnerBrandRouter";
import MerchantConfigView from "../components/admin/merchant/MerchantConfigView";
import JobActivityTemplateDetails from "../components/admin/surveyQuestionsTool/JobActivityTemplateDetails";
import OrganisationUsersRouter from "./OrganisationUsersRouter";
import MaterialWorkspaceContainer from "../components/v5/workspace/MaterialWorkspaceContainer";
import LeadCustomFieldsView from "../components/admin/customFields/LeadCustomFieldsView";
import JobCustomFieldsView from "../components/admin/customFields/JobCustomFieldsView";
import ManageAssetsList from "../components/admin/manageAssets/ManageAssetsList";
import AdminMenuPage from "../components/admin/adminMenuPage/AdminMenuPage";
import RestrictedRoute from "./route/RestrictedRoute";
import {UserPermission} from "../model/user/UserPermission";
import EditAssetForm from "../components/admin/assets/form/edit/EditAssetForm";
import AssetWorkspaceContainer from "../components/v5/workspace/AssetWorkspaceContainer";
import CreateAssetForm from "../components/admin/assets/form/create/CreateAssetForm";
import PartnerBrandCustomFieldsView from "../components/admin/customFields/PartnerBrandCustomFieldsView";
import LeadSidebarConfig from "../components/admin/sidebarConfig/LeadSidebarConfig";
import JobSidebarConfig from "../components/admin/sidebarConfig/JobSidebarConfig";
import FinanceProductList from "../components/admin/financeProduct/FinanceProductList";
import JobTypesList from "../components/admin/jobTypes/JobTypesList";
import UtilitiesList from "../components/admin/utilities/UtilitiesList";
import BulkJobManagement from "../components/admin/job/BulkJobManagement";
import CodatErrorsList from "../components/codatError/CodatErrorsList";
import CodatOperationErrorsList from "../components/codatOperationError/CodatOperationErrorsList";
import XeroOperationErrorsList from "../components/xeroOperationError/XeroOperationErrorsList";
import MangeGrahamParts from "../components/parts/MangeGrahamParts";
import MasterRegsCatalog from "../components/admin/masterregs/MasterRegsCatalog";
import HistoricalJobImportsList from "../components/admin/historicalJobs/HistoricalJobImportsList";

interface RouteProps {
	/**
	 * Route match url.
	 */
	match: match<any>;
}

/**
 * Admin router view.
 */
export default class AdminRouter extends React.PureComponent <RouteProps> {

	render() {
		return (
			<Switch>
				<RestrictedRoute
					exact
					path={this.props.match.url}
					component={AdminMenuPage}
					allowedPermissions={[UserPermission.AdminAll,
						UserPermission.AdminPartnerBrands,
						UserPermission.AdminUsers,
						UserPermission.AdminMerchantBranchLocations]}/>
				<Route path={this.props.match.url + "/users"} component={OrganisationUsersRouter}/>
				<AdminRoute exact path={this.props.match.url + "/categories"} component={CategoriesConfigView}/>
				<AdminRoute exact path={this.props.match.url + "/channels"} component={AcquisitionChannelConfigView}/>
				<AdminRoute exact path={this.props.match.url + "/assets/create"} component={CreateAssetForm}/>
				<AdminRoute exact path={this.props.match.url + "/assets"} component={AssetWorkspaceContainer}/>
				<AdminRoute exact path={this.props.match.url + "/assets/:assetId"} component={EditAssetForm}/>
				<AdminRoute exact path={this.props.match.url + "/assetcategories"} component={AssetCategoryConfigView}/>
				<AdminRoute exact path={this.props.match.url + "/manageassets"} component={ManageAssetsList}/>
				<AdminRoute exact path={this.props.match.url + "/leadtypes"} component={LeadTypesConfigView}/>
				<AdminRoute exact path={this.props.match.url + "/jobtypes"} component={JobTypesList}/>
				<AdminRoute exact path={this.props.match.url + "/utilities"} component={UtilitiesList}/>
				<AdminRoute exact path={this.props.match.url + "/masterregscatalog"} component={MasterRegsCatalog}/>
				<AdminRoute exact path={this.props.match.url + "/historicaljobs"} component={HistoricalJobImportsList}/>
				<AdminRoute exact path={this.props.match.url + "/postcodes"} component={PostcodesList}/>
				<Route path={this.props.match.url + "/leadstatuses"} component={LeadStatusesRouter}/>
				<AdminRoute exact path={this.props.match.url + "/jobstatuses"} component={JobStatusesList}/>
				<AdminRoute exact path={this.props.match.url + "/tasks"} component={TaskList}/>
				<Route path={this.props.match.url + "/activity"} component={SurveyRouter}/>
				<AdminRoute exact path={this.props.match.url + "/jobactivity/:activityId"}
							component={JobActivityTemplateDetails}/>
				<Route path={this.props.match.url + "/brands"} component={BrandRouter}/>
				<Route path={this.props.match.url + "/partnerbrands"} component={PartnerBrandRouter}/>
				<Route path={this.props.match.url + "/merchants"} component={MerchantConfigView}/>
				<Route path={this.props.match.url + "/materials"} component={MaterialWorkspaceContainer}/>
				<AdminRoute path={this.props.match.url + "/leadcustomfields"} component={LeadCustomFieldsView}/>
				<AdminRoute path={this.props.match.url + "/jobcustomfields"} component={JobCustomFieldsView}/>
				<AdminRoute path={this.props.match.url + "/partnerbrandcustomfields"} component={PartnerBrandCustomFieldsView}/>
				<AdminRoute path={this.props.match.url + "/jobsidebarconfig"} component={JobSidebarConfig}/>
				<AdminRoute path={this.props.match.url + "/leadsidebarconfig"} component={LeadSidebarConfig}/>
				<AdminRoute path={this.props.match.url + "/financeproducts"} component={FinanceProductList}/>
				<AdminRoute exact path={this.props.match.url + "/bulkjobmanagement"} component={BulkJobManagement}/>
				<AdminRoute exact path={this.props.match.url + "/codaterrors"} component={CodatErrorsList}/>
				<AdminRoute exact path={this.props.match.url + "/codatoperationerrors"} component={CodatOperationErrorsList}/>
				<AdminRoute exact path={this.props.match.url + "/xerooperationerrors"} component={XeroOperationErrorsList}/>
				<AdminRoute exact path={this.props.match.url + "/parts/graham"} component={MangeGrahamParts}/>
			</Switch>
		)
	}
}
